import { render, staticRenderFns } from "./BookingRoomServiceDialog.vue?vue&type=template&id=e6d16ff0&lang=true"
import script from "./BookingRoomServiceDialog.vue?vue&type=script&lang=js"
export * from "./BookingRoomServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports